import React, { Fragment, useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const BarChart = (props) => {
    let { dashboard, data } = props;
    let dashboardType = parseInt(dashboard[2]);
    let dashboardName = dashboard[1];
    let categories = [];
    let chartdata = [];
    for (let i = 0; i < data[2].length; i++) {
        categories.push(data[2][i][0]);
        let paramstr = { name: data[2][i][0] + "  " + parseInt(data[2][i][1], 10).toLocaleString() + "  ", y: parseInt(data[2][i][1], 10) };
        chartdata.push(paramstr);
    }
    let options = {};
    if (dashboardType === 1) {
        options = {
            chart: {
                type: 'bar'
            },
            title: {
                text: "",
            },
            tooltip: {
                pointFormat: ' '
            },
            subtitle: {
                text: null
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }

            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                }
            },
            series: [{
                name: dashboardName,
                colorByPoint: true,
                data: chartdata,
            }]

        }
    } else if (dashboardType === 0) {
        options = {

            title: {
                text: ""
            },
            tooltip: {
                pointFormat: ' '
            },
            subtitle: {
                text: null
            },

            xAxis: {
                categories: categories
            },
            credits: {
                enabled: false
            },
            series: [{
                type: 'column',
                colorByPoint: true,
                data: chartdata,
                showInLegend: false
            }]

        }
    }
    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
};

export default BarChart;